// https://developers.facebook.com/docs/meta-pixel/reference#standard-events

import {
    type FragmentType,
    getFragmentData,
    graphql
} from '~/resources/graphql'
import { Decimal } from '~/composables/support/decimal'

export const AnalyticsMetaCreateCheckoutResultFragment = graphql(`
    fragment AnalyticsMetaCreateCheckoutResultFragment on CreateCheckoutResult {
        record {
            id
            subtotal
            facility {
                organization {
                    metaPixel
                    metaPixelEcommerceEvents
                    currencyFormat
                }
            }
            items {
                __typename
                ... on CartContractItem {
                    lineItems {
                        quantity
                        unitPrice
                        originalUnitPrice
                        promotionCode
                        productVariant {
                            id
                            variantDisplay
                            product {
                                description
                            }
                        }
                    }
                }
            }
        }
    }
`)

export function metaEmitInitiateCheckoutEvent(
    createCheckoutResult: FragmentType<
        typeof AnalyticsMetaCreateCheckoutResultFragment
    >
) {
    try {
        // @ts-ignore
        if (!window.fbq) {
            return
        }

        const createCheckoutResultData = getFragmentData(
            AnalyticsMetaCreateCheckoutResultFragment,
            createCheckoutResult
        )

        if (createCheckoutResultData.record === null) {
            // Payment only - no invoice created
            return
        }

        // Check analytics events are configured
        if (
            createCheckoutResultData.record.facility.organization.metaPixel ===
                '' ||
            !createCheckoutResultData.record.facility.organization
                .metaPixelEcommerceEvents
        ) {
            return
        }

        const content_ids = createCheckoutResultData.record.items.flatMap(
            item => {
                if (item.__typename !== 'CartContractItem') {
                    return []
                }

                return item.lineItems.map(lineItem => {
                    return lineItem.productVariant.id
                })
            }
        )

        const contents = createCheckoutResultData.record.items.flatMap(item => {
            if (item.__typename !== 'CartContractItem') {
                return []
            }

            return item.lineItems.map(lineItem => {
                return {
                    // Required fields
                    id: lineItem.productVariant.id,
                    quantity: lineItem.quantity,

                    // Custom fields
                    item_name: lineItem.productVariant.product.description,
                    coupon: lineItem.promotionCode,
                    discount: Number(
                        new Decimal(lineItem.unitPrice)
                            .minus(new Decimal(lineItem.originalUnitPrice))
                            .toFixed(2)
                    ),
                    item_variant: lineItem.productVariant.variantDisplay,
                    price: Number(lineItem.unitPrice)
                }
            })
        })

        // @ts-ignore
        fbq('track', 'InitiateCheckout', {
            // Sum of (price * quantity) for all items.
            value: Number(createCheckoutResultData.record.subtotal),
            currency:
                createCheckoutResultData.record.facility.organization
                    .currencyFormat,
            num_items: createCheckoutResultData.record.items.length,
            content_ids,
            contents
        })
    } catch (e) {
        // Swallow errors
    }
}
